import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M4 13.3327L4.66667 10.666H2L2.33333 9.33268H5L5.66667 6.66602H3L3.33333 5.33268H6L6.66667 2.66602H8L7.33333 5.33268H10L10.6667 2.66602H12L11.3333 5.33268H14L13.6667 6.66602H11L10.3333 9.33268H13L12.6667 10.666H10L9.33333 13.3327H8L8.66667 10.666H6L5.33333 13.3327H4ZM6.33333 9.33268H9L9.66667 6.66602H7L6.33333 9.33268Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgTag);
export default ForwardRef;
